import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext"; // ajusta la ruta según tu proyecto
import "./emailconfirmation.css";

function EmailConfirmation() {
  const [counter, setCounter] = useState(60);
  const { user } = useContext(AuthContext); // obtiene la info del usuario

  useEffect(() => {
    if (counter > 0) {
      const timer = setTimeout(() => setCounter(counter - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [counter]);

  const handleResend = async () => {
    try {
      // Asegúrate de que 'user' existe y tiene la propiedad 'email'
      if (!user || !user.email) {
        alert("No se encontró el email del usuario.");
        return;
      }
      const response = await fetch("https://workingunidos.com/api/auth/send-email-confirmation", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: user.email }), // usa el email del usuario actual
      });

      if (!response.ok) {
        throw new Error("Error al reenviar el correo de confirmación");
      }

      alert("Correo reenviado");
      setCounter(60);
    } catch (error) {
      console.error(error);
      alert("Hubo un error al reenviar el correo");
    }
  };

  return (
    <div className="email-confirmation-container">
      <div className="email-confirmation-card">
        <h2 className="email-confirmation-title">Verifica tu correo electrónico</h2>
        <p className="email-confirmation-text">
          Se ha enviado un correo de confirmación a tu dirección.
          Por favor, revisa tu correo y haz clic en el enlace para confirmar tu cuenta.
        </p>
        <p className="email-confirmation-timer">
          {counter > 0
            ? `Podrás reenviar el correo en ${counter} segundos`
            : "Ya puedes reenviar el correo."}
        </p>
        <button
          className="email-confirmation-button"
          onClick={handleResend}
          disabled={counter > 0}
        >
          Reenviar correo
        </button>
      </div>
    </div>
  );
}

export default EmailConfirmation;